export default __webpack_public_path__ + "static/media/Snd_LowerHDivedown.6009f843.mp3";